import dayjs from 'dayjs';

/**
 * Get a date object from the given hours, minutes, seconds, format, pmLabel and amPm.
 * @param {string} hours - The hours.
 * @param {string} minutes - The minutes.
 * @param {string} seconds - The seconds.
 * @param {string} format - The format.
 * @param {string} pmLabel - The pm label.
 * @param {string} amPm - The am pm.
 * @returns {Date}
 */
export function getDate(hours, minutes, seconds, format, pmLabel, amPm) {
    const date = dayjs();
    let _hours = parseInt(hours, 10);
    const _minutes = parseInt(minutes, 10);
    const _seconds = parseInt(seconds, 10);

    if (Number.isNaN(_hours)) {
        _hours = 0;
    }

    if (format === '12') {
        _hours %= 12;
        if (amPm === pmLabel) {
            _hours += 12;
        }
    }

    return date
        .hour(_hours)
        .minute(Number.isNaN(_minutes) ? 0 : _minutes)
        .second(Number.isNaN(_seconds) ? 0 : _seconds)
        .millisecond(0)
        .toDate();
}
